import { View, Text } from "@react-pdf/renderer";
import styles from "./styles";
import FaNum from "./FaNum";

export default function PaymentInfo({ order }) {
  return (
    <View style={styles.extraBox}>
      <View style={styles.extraCard}>
        <Text style={styles.extraTitle}>اطلاعات پرداخت</Text>

        <View style={styles.extraRow}>
          <Text style={styles.extraRowTitle}>وضعیت</Text>
          <Text>{order.payment.status}</Text>
        </View>

        <View style={styles.extraRow}>
          <Text style={styles.extraRowTitle}>مبلغ</Text>
          <Text>
            <FaNum>{order.payment.amount}</FaNum> تومان
          </Text>
        </View>

        <View style={styles.extraRow}>
          <Text style={styles.extraRowTitle}>روش پرداخت</Text>
          <Text>{order.payment.method}</Text>
        </View>

        <View style={styles.extraRowEnd}>
          <Text style={styles.extraRowTitle}>شماره پیگیری</Text>
          <Text>
            {order.payment.system_trace_no ? (
              <FaNum>{order.payment.system_trace_no}</FaNum>
            ) : (
              "-"
            )}
          </Text>
        </View>
      </View>
      <View style={styles.extraCard}>
        <Text style={styles.extraTitle}>اطلاعات ارسال</Text>
        <View style={styles.extraRow}>
          <Text style={styles.extraRowTitle}>نوع ارسال</Text>
          <Text>{order.deliveryType.sendType}</Text>
        </View>
        <View style={styles.extraRowEnd}>
          <Text style={styles.extraRowTitle}>وضعیت مرسوله</Text>
          <Text>{order.data.status}</Text>
        </View>
      </View>

    </View>
  );
}
